import objectPath from "object-path";
import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const GET_LIST_CONFIGURE_BILLING_TIME =
  "GET_LIST_CONFIGURE_BILLING_TIME";
export const GET_LIST_CONFIGURE_BILLING_TIME_ERROR =
  "GET_LIST_CONFIGURE_BILLING_TIME_ERROR";
export const GET_LIST_CONFIGURE_BILLING_TIME_SUCCESS =
  "GET_LIST_CONFIGURE_BILLING_TIME_SUCCESS";

export const COUNT_LIST_CONFIGURE_BILLING_TIME =
  "COUNT_LIST_CONFIGURE_BILLING_TIME";
export const COUNT_LIST_CONFIGURE_BILLING_TIME_ERROR =
  "COUNT_LIST_CONFIGURE_BILLING_TIME_ERROR";
export const COUNT_LIST_CONFIGURE_BILLING_TIME_SUCCESS =
  "COUNT_LIST_CONFIGURE_BILLING_TIME_SUCCESS";

export const ADD_CONFIGURE_BILLING_TIME = "ADD_CONFIGURE_BILLING_TIME";
export const ADD_CONFIGURE_BILLING_TIME_ERROR =
  "ADD_CONFIGURE_BILLING_TIME_ERROR";
export const ADD_CONFIGURE_BILLING_TIME_SUCCESS =
  "ADD_CONFIGURE_BILLING_TIME_SUCCESS";

export const EDIT_CONFIGURE_BILLING_TIME = "EDIT_CONFIGURE_BILLING_TIME";
export const EDIT_CONFIGURE_BILLING_TIME_ERROR =
  "EDIT_CONFIGURE_BILLING_TIME_ERROR";
export const EDIT_CONFIGURE_BILLING_TIME_SUCCESS =
  "EDIT_CONFIGURE_BILLING_TIME_SUCCESS";

export const DELETE_CONFIGURE_BILLING_TIME = "DELETE_CONFIGURE_BILLING_TIME";
export const DELETE_CONFIGURE_BILLING_TIME_ERROR =
  "DELETE_CONFIGURE_BILLING_TIME_ERROR";
export const DELETE_CONFIGURE_BILLING_TIME_SUCCESS =
  "DELETE_CONFIGURE_BILLING_TIME_SUCCESS";

const initialState = {
  items: [],
  error: false,
  loading: false,
};

export const configureBillingTimeReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_CONFIGURE_BILLING_TIME:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_CONFIGURE_BILLING_TIME_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload,
      };
    case GET_LIST_CONFIGURE_BILLING_TIME_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case EDIT_CONFIGURE_BILLING_TIME:
      return {
        ...state,
        loading: true,
      };
    case EDIT_CONFIGURE_BILLING_TIME_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case EDIT_CONFIGURE_BILLING_TIME_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case DELETE_CONFIGURE_BILLING_TIME:
      return {
        ...state,
        loading: true,
      };
    case DELETE_CONFIGURE_BILLING_TIME_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_CONFIGURE_BILLING_TIME_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case COUNT_LIST_CONFIGURE_BILLING_TIME:
      return {
        ...state,
      };
    case COUNT_LIST_CONFIGURE_BILLING_TIME_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_LIST_CONFIGURE_BILLING_TIME_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */

export const getListConfigureBillingTime = (order, limit, skip, where) => ({
  type: GET_LIST_CONFIGURE_BILLING_TIME,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countListConfigureBillingTime = (where) => ({
  type: COUNT_LIST_CONFIGURE_BILLING_TIME,
  data: {
    where,
  },
});

const addConfig = (number, type, durationType) => ({
  type: ADD_CONFIGURE_BILLING_TIME,
  data: {
    number,
    type,
    durationType,
  },
});

const editConfig = (number, inboundCall, outboundCall) => ({
  type: EDIT_CONFIGURE_BILLING_TIME,
  data: {
    number,
    inboundCall,
    outboundCall,
  },
});

const deleteConfig = (number) => ({
  type: DELETE_CONFIGURE_BILLING_TIME,
  data: {
    number,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListConfigureBillingTime,
      countListConfigureBillingTime,
      addConfig,
      editConfig,
      deleteConfig,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListConfigureBillingTimeApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/cloud-pbx/inbound-call/duration-report", {
    order,
    limit,
    skip,
    ...where,
  });
};

const countListConfigureBillingTimeApi = (where) => {
  return apiCaller.getData("/cloud-pbx/inbound-call/duration-count", {
    ...where,
  });
};

const editConfigApi = (number, inboundCall, outboundCall) => {
  return apiCaller.put(`cloud-pbx/number/${number}`, {
    attributes: { "inbound-call": inboundCall, "outbound-call": outboundCall },
  });
};

const deleteConfigApi = (number) => {
  return apiCaller.del(`cloud-pbx/number/${number}`);
};

/**
 * sagas
 */

export const editConfigFlow = function* () {
  while (true) {
    const action = yield take(EDIT_CONFIGURE_BILLING_TIME);
    try {
      const res = yield call(
        editConfigApi,
        action.data.number,
        action.data.inboundCall,
        action.data.outboundCall
      );
      yield put({
        type: EDIT_CONFIGURE_BILLING_TIME_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: EDIT_CONFIGURE_BILLING_TIME_ERROR, error });
    }
  }
};

export const deleteConfigFlow = function* () {
  while (true) {
    const action = yield take(DELETE_CONFIGURE_BILLING_TIME);
    try {
      const res = yield call(deleteConfigApi, action.data.number);
      yield put({
        type: DELETE_CONFIGURE_BILLING_TIME_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: DELETE_CONFIGURE_BILLING_TIME_ERROR, error });
    }
  }
};

export const getListConfigureBillingTimeFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_CONFIGURE_BILLING_TIME);
    try {
      const res = yield call(
        getListConfigureBillingTimeApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      const data = res.data.sort(function (a, b) {
        var n = Date.parse(b.date) - Date.parse(a.date);
        if (n != 0) {
          return n;
        }
        return ("" + a.number).localeCompare(b.number);
      });

      const reportGroups = {
        date: {
          fields: ["date"],
        },
      };

      data.forEach((item) => {
        item.groups = {};
        item.inboundDuration =
          item.inboundDuration === "duration"
            ? "Thời gian kết nối"
            : item.inboundDuration === "answerDuration"
            ? "Thời gian trả lời"
            : "";
        item.outboundDuration =
          item.outboundDuration === "duration"
            ? "Thời gian kết nối"
            : item.outboundDuration === "answerDuration"
            ? "Thời gian trả lời"
            : "";
        for (const groupName in reportGroups) {
          // eslint-disable-next-line no-prototype-builtins
          if (reportGroups.hasOwnProperty(groupName)) {
            let foundItemsInGroup = data.filter((i) => {
              let reportGroup = reportGroups[groupName];
              let condition = true;
              if (reportGroup) {
                reportGroup.fields.forEach((field) => {
                  condition &=
                    objectPath.get(i, field) === objectPath.get(item, field);
                });
              }
              return condition;
            });
            let indexInGroup = foundItemsInGroup.indexOf(item);

            item.groups[groupName] = {
              index: indexInGroup,
              count: foundItemsInGroup.length,
            };
          }
        }
        if (!item.number) {
          item.number = "Total";
        }
      });
      yield put({
        type: GET_LIST_CONFIGURE_BILLING_TIME_SUCCESS,
        payload: { ...data },
      });
    } catch (error) {
      yield put({ type: GET_LIST_CONFIGURE_BILLING_TIME_ERROR, error });
    }
  }
};

export const countListConfigureBillingTimeFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_CONFIGURE_BILLING_TIME);
    try {
      const res = yield call(
        countListConfigureBillingTimeApi,
        action.data.where
      );
      yield put({
        type: COUNT_LIST_CONFIGURE_BILLING_TIME_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_CONFIGURE_BILLING_TIME_ERROR, error });
    }
  }
};
